<template>
    <header id="header-avaliacoes" :class="{ home: !showReturn }">
        <div class="header-wrapper" :class="{ 'hidden-header-logo': this.info && showReturn }">
            <router-link
                class="d-flex flex-align-center"
                v-if="showReturn"
                :to="{ name: 'home', query: $route.query }"
            >
                <i class="icon-cr icon-chevron-left" />
            </router-link>
            <i class="header-logo-cr logo-cr-text" />
            <div class="v-divider" />
            <span class="logo-text">Painel de Avaliações</span>
        </div>
        <div v-if="info && showReturn" class="info-wrapper">
            <span class="info-text">Você está avaliando: </span>
            <span class="info-title text-uppercase">{{ this.title }}</span>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'AvaliacoesHeader',

        props: {
            info: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
            },
        },

        data() {
            return {
                showReturn: false,
            };
        },

        watch: {
            $route() {
                this.showReturn = this.$route.name !== 'home' && this.$route.name !== 'not-found';
            },
        },
    };
</script>
